<template>
  <div
    id="app"
    :class="{ 'highcontrast-active': $store.getters.isHighContrastSelected }"
  >
    <component :is="layout">
      <router-view class="app-view" />
    </component>
  </div>
</template>

<script>
const defaultLayout = 'default'

export default {
  computed: {
    layout() {
      return 'layout-' + (this.$route.meta.layout || defaultLayout)
    }
  },
  created() {
    localStorage.clear()
  },
  mounted() {
    if (process.env.NODE_ENV !== 'development') {
      this.createAnalyticsScript(process.env.VUE_APP_ANALYTICS_ID)
    }
  },
  methods: {
    createAnalyticsScript(id) {
      let analyticScript = document.createElement('script')
      analyticScript.setAttribute(
        'src',
        'https://www.googletagmanager.com/gtag/js?id=' + id
      )

      let scriptContent = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${id}');`
      let script = document.createElement('script')
      script.innerHTML = scriptContent

      document.body.appendChild(analyticScript)
      document.body.appendChild(script)
    }
  }
}
</script>

<style lang="scss">
@import '~buefy/dist/buefy.css';
@import 'assets/stylesheets/icons';
@import 'assets/stylesheets/styleguide.scss';
@import 'assets/stylesheets/custom-props.scss';

html {
  height: 100%;
}
body {
  min-height: 100%;
}

body {
  font-family: $font-primary;
  color: var(--neutral-color-1);
  font-size: $body-1;
  line-height: $lh-body-1;
}

i {
  font-size: 1.25rem;
}

#app {
  min-height: 100vh;
}

.view-mobile {
  display: none !important;
}

.container-sarah {
  margin: 0 auto;
  position: relative;
  max-width: 80rem;
  width: 92%;
}

@media (max-width: 64rem) {
  .form-layout .issue-certificate > .container-sarah {
    width: 100%;
  }

  .view-mobile {
    display: inline !important;
  }

  .view-desktop {
    display: none !important;
  }
}
#app {
  height: 100%;
}
.app-view {
  height: 100%;
  padding-bottom: 0.5rem;
}
@media print {
  .floating-buttons,
  .pagination,
  .breadcrumb,
  header,
  .profile_bg {
    display: none !important;
  }
}

.b-sidebar .sidebar-content .menu-list a.is-active {
  background-color: var(--orange);
}

.list {
  background-color: transparent;
}

.navbar-burger:hover {
  background-color: transparent;
}

.highcontrast-active {
  .invert-on-highcontrast {
    filter: invert(1);
  }
}

.clearFilter {
  position: relative;
  top: -0.1875rem;
  max-width: 8.4375rem;

  color: var(--orange);
  font-family: Roboto;
  font-size: 0.875rem;
  font-weight: $font-semi-bold;
  line-height: 2.5;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

// ==================================================
// Ajustes para a aplicação de temas
// ==================================================
#app,
.navbar,
.table,
.input,
.textarea {
  background-color: var(--bg-color-primary);
}

[class*='blue']::before,
[class*='ic_edit']::before,
[class*='ic_link']::before,
.container-sarah i[class*='ic_link']::before {
  color: var(--light-blue);
}

[class*='orange']::before {
  color: var(--orange);
}

[class*='gray']::before {
  color: var(--gray-500);
}

.info_subtitle,
.select select,
.select select option {
  color: var(--gray-700);
}

.button:hover,
.button.is-hovered {
  border-color: var(--gray-500);

  color: var(--gray-800);
}

h1,
.navbar a.navbar-burger span,
.label,
.table thead td,
.table thead th,
.checkbox:hover,
.radio:hover {
  color: var(--gray-800);
}

.button,
.table,
.title {
  color: var(--text-color-primary);
}

.dropdown-content,
.datepicker .dropdown-content,
.select select,
.b-sidebar .menu {
  background-color: var(--white);
}

.dropdown-item,
.dropdown .dropdown-menu .has-link a,
.card,
.menu,
.menu-list a,
.tabs a,
.input,
.textarea {
  color: var(--neutral-color-1);
}

.b-sidebar .sidebar-content.is-light {
  background-color: var(--neutral-color-5);
}

a.dropdown-item:hover,
.dropdown .dropdown-menu .has-link a:hover,
button.dropdown-item:hover {
  color: var(--black);

  background-color: var(--neutral-color-5);
}

.dropdown {
  input.input:focus,
  a.pagination-previous:focus,
  a.pagination-next:focus,
  .datepicker-header .pagination-list .select::after,
  .select select:focus {
    border-color: var(--gray-700);
  }

  .datepicker-table .datepicker-body .datepicker-cell.is-selectable {
    color: var(--gray-700);
  }

  .datepicker-table .datepicker-body .datepicker-cell.is-unselectable {
    color: var(--neutral-color-4);
  }

  .datepicker-table .datepicker-body .datepicker-cell.is-selected {
    background-color: var(--orange);

    color: var(--white);
  }

  .datepicker-table .datepicker-body .datepicker-cell.is-today {
    border-color: var(--orange);
  }

  .datepicker .dropdown-trigger .control input.input:focus,
  .datepicker-header .select select:focus {
    box-shadow: unset;
  }
}
</style>
